<template>
  <q-page padding>
    <div class="row col-12">
      <p class="titulo-pagina text-h6 text-brand-5 text-weight-bold">
        Listagem de Requisições
      </p>
    </div>

    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div class="col-md-2 col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs">Unidade</div>
        <lista-unidades-select />
      </div>
      <div class="col-md-2 col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs">Centro de Custo</div>
        <q-input dense outlined v-model="filtros.centro" />
      </div>
      <div class="col-md-2 col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs responsivo-teste">
          N: da Requisição
        </div>
        <q-input dense outlined v-model="filtros.numeroRequisicao" />
      </div>

      <div class="col-md-2 col-xs-3">
        <div class="q-ml-sm text-brand-5 texto-inputs">Solicitante</div>
        <q-input
          :disable="filtros.listaUser"
          dense
          outlined
          v-model="filtros.solicitante"
        />
      </div>
      <div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Categoria Entre</div>
        <q-select
          :options="categoriaEntreOptions"
          dense
          outlined
          :display-value="filtros.intervalo ? filtros.intervalo.label : 'Todos'"
          v-model="filtros.intervalo"
        />
      </div>
      <div class="bnt-filtrar">
        <p></p>
        <q-btn
          color="primary"
          icon="filter_alt"
          no-caps
          class="q-mt-xs"
          label="Filtrar"
          @click="escolherRequisicao()"
        />
      </div>
      <div class="col-md-2 col-sm-3 col-xs-5 toggle-container">
        <div class="q-ml-sm toggle-text">User Logado</div>
        <div>
          <q-toggle
            class="q-ml-sm"
            checked-icon="check"
            color="green"
            unchecked-icon="clear"
            v-model="filtros.listaUser"
          />
          <span class="q-ml-sm toggle-text">{{
            filtros.listaUser ? "Habilitado" : "Desabilitado"
          }}</span>
        </div>
      </div>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey bg-grey-3 q-mt-xl"
      active-color="primary"
      indicator-color="primary"
      align="justify"
      narrow-indicator
    >
      <q-tab name="aprovacao" label="Aguardando Aprovação" />
      <q-tab name="finalizacao" label="Aguardando Finalização" />
      <q-tab name="finalizadas" label="Requisições Finalizadas" />
    </q-tabs>
    <div class="q-mt-xl">
      <p class="texto-titulo text-h6 text-brand-5 text-weight-bold">
        {{ quantidade }}
        {{
          tab == "aprovacao"
            ? "Aguardando Aprovação"
            : tab == "finalizacao"
            ? "Aguardando Finalização"
            : tab == "finalizadas"
            ? "Requisições Finalizadas"
            : tab == "deletadas"
            ? "Requisições Deletadas"
            : ""
        }}
      </p>
      <q-table
        :grid="$q.screen.lt.sm"
        table-header-class="bg-accent text-width-bold"
        :rows="listaRequisicao"
        :columns="columns"
        :loading="disable"
        color="primary"
        class="tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        dense
        flat
        v-model:pagination="pagination"
        no-data-label="Sem dados"
      >
        <template #body-cell-selecionar="props">
          <q-td :props="props">
            <q-checkbox
              :disable="tab == 'deletados' || tab == 'finalizado'"
              v-model="selecionados"
              :val="props.row.id"
            />
          </q-td>
        </template>
        <template #body-cell-produto="props">
          <q-td :props="props">
            <div v-for="(produto, index) in props.row.products" :key="index">
              <span
                >{{ Math.trunc(produto.pivot.amount) }} x {{ produto.code }}

                {{ produto.name.substring(0, 20) + "..." }}</span
              >
              <q-tooltip
                >{{ Math.trunc(produto.pivot.amount) }} x {{ produto.code }} -
                {{ produto.name }}</q-tooltip
              >
            </div>
          </q-td>
        </template>
        <template #body-cell-assinatura="props">
          <q-td :props="props">
            <q-img
              v-if="props.row.voucher_images.length != 0"
              :src="props.row.voucher_images[0].url"
              fit="contain"
              style="max-width: 30px; height: 45px"
            />
          </q-td>
        </template>
        <template #body-cell-criada="props">
          <q-td :props="props">
            <div class="column align">
              <span>{{
                props.row.created_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
              <span>{{ props.row.created_at.split(" ")[1] }}</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-solicitante="props">
          <q-td :props="props">
            <div>
              <span>{{ props.row?.plantiff?.name }}</span>
            </div>
          </q-td>
        </template>
        <template #body-cell-acoes="props">
          <q-td :props="props">
            <div v-if="tab != 'deletados'" class="row botoes">
              <router-link
                :to="{
                  name: 'backoffice/requisicao-detalhe-teste',
                  params: { requisicaoId: props.row.id },
                }"
              >
                <q-icon
                  class="pointer"
                  size="sm"
                  color="blue"
                  name="add_circle"
                />
              </router-link>
            </div>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :direction-links="true"
          size="sm"
          :max-pages="6"
        />
      </div>
    </div>
  </q-page>
</template>

<script setup>
import { onMounted, ref, computed, watch } from "vue";
// import { useRouter } from "vue-router";
import { useStore } from "vuex";
// import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "selecionar",
    label: "Selecionar",
    field: (row) => row.id,
    align: "center",
    sortable: false,
  },
  {
    name: "id",
    label: "ID",
    field: (row) => row.id,
    align: "center",
    sortable: false,
  },
  {
    name: "unidade",
    label: "Unidade",
    field: (row) => (row.vendor ? row.vendor.name : "Sem unidade"),
    align: "left",
    sortable: false,
  },
  {
    name: "solicitante",
    label: "Solicitante",
    field: (row) => (row.plantiff ? row.plantiff.name : ""),
    align: "left",
    sortable: false,
  },
  {
    name: "centrodecusto",
    label: "Centro de Custo",
    field: (row) => (row.cost_center ? row.cost_center.name : ""),
    align: "left",
    sortable: false,
  },
  {
    name: "produto",
    label: "Produtos",
    field: (row) => row.products,
    align: "left",
    sortable: false,
  },
  {
    name: "numprodutos",
    label: "N de Produtos",
    field: (row) => row.products.length,
    align: "left",
    sortable: false,
  },
  {
    name: "criada",
    label: "Criada",
    field: (row) => row.created_at.split(" ")[0].split("-").reverse().join("/"),
    align: "center",
    sortable: false,
  },
  {
    name: "assinatura",
    label: "Assinatura",
    field: (row) => row.created_at.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
    sortable: false,
  },
  {
    name: "status",
    label: "Status Atual",
    field: (row) => row.status,
    align: "left",
    sortable: false,
  },
  {
    name: "acoes",
    label: "Ações",
    field: "acoes",
    align: "left",
    sortable: false,
  },
];

const store = useStore();
// const quasar = useQuasar();
// const router = useRouter();

const filtros = ref({
  centro: "",
  numeroRequisicao: "",
  solicitante: "",
  intervalo: "",
  listaUser: false,
});
const tab = ref("aprovacao");

const quantidade = ref("");
const pagination = ref({
  sortBy: "desc",
  descending: false,
  page: 1,
  rowsPerPage: 50,
  rowsNumber: 50,
});
const selecionados = ref([]);
const listaRequisicao = ref([]);
const disable = ref(true);
const categoriaEntreOptions = ref([
  {
    label: "Todos",
    value: "",
  },
  {
    label: "Categoria Proritária",
    value: "A",
  },
  {
    label: "Intervalo de 7 dias",
    value: "B",
  },
  {
    label: "Rascunho",
    value: "rascunho",
  },
  {
    label: "Intervalo de 15 dias",
    value: "C",
  },
]);
const pagesNumber = computed(() =>
  Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
);

const escolherRequisicao = async () => {
  listaRequisicao.value = [];
  store.dispatch("pdt/hiddenHeader", true);
  if (tab.value == "aprovacao") {
    listarRequisicoesPendentes();
  } else if (tab.value == "finalizacao") {
    listarRequisicoesFinalizacao();
  } else if (tab.value == "deletados") {
    listarRequisicoesDeletado();
  } else if (tab.value == "finalizadas") {
    listarRequisicoesFinalizado();
  }
};

const listarRequisicoesPendentes = async (page = 1, rowsPerPage = 50) => {
  try {
    disable.value = true;
    const response = await store.dispatch("requisicao/listar", {
      status: "pendente",
      per_page: rowsPerPage,
      current_page: page,
      id: filtros.value.numeroRequisicao,
      cost_center_search: filtros.value.centro,
      plantiff_search: filtros.value.listaUser
        ? store.state.autenticacao.usuarioLogado.id
        : filtros.value.solicitante,
      vendor_id: await store.state.org.unidadeData.id,
      vendor_id_voucher: await store.state.org.unidadeData.id,
      categoria: filtros.value.intervalo?.value,
    });
    listaRequisicao.value = response.data.results.data;
    quantidade.value = response.data.results.total;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    pagination.value.page = response.data.results.current_page;
    disable.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarRequisicoesFinalizacao = async (page = 1, rowsPerPage = 50) => {
  try {
    disable.value = true;
    let response = await store.dispatch("requisicao/listar", {
      status: "aprovado",
      per_page: rowsPerPage,
      current_page: page,
      id: filtros.value.numeroRequisicao,
      cost_center_search: filtros.value.centro,
      plantiff_search: filtros.value.listaUser
        ? store.state.autenticacao.usuarioLogado.id
        : filtros.value.solicitante,
      vendor_id: await store.state.org.unidadeData.id,
      vendor_id_voucher: await store.state.org.unidadeData.id,
      categoria: filtros.value.categoria?.value,
    });
    listaRequisicao.value = response.data.results.data;
    quantidade.value = response.data.results.total;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    pagination.value.page = response.data.results.current_page;
    disable.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarRequisicoesFinalizado = async (page = 1, rowsPerPage = 50) => {
  disable.value = true;
  try {
    let response = await store.dispatch("requisicao/listar", {
      status: "finalizado",
      per_page: rowsPerPage,
      current_page: page,
      id: filtros.value.numeroRequisicao,
      cost_center_search: filtros.value.centro,
      plantiff_search: filtros.value.listaUser
        ? store.state.autenticacao.usuarioLogado.id
        : filtros.value.solicitante,
      vendor_id: await store.state.org.unidadeData.id,
      vendor_id_voucher: await store.state.org.unidadeData.id,
      categoria: filtros.value.categoria?.value,
    });

    listaRequisicao.value = response.data.results.data;
    quantidade.value = response.data.results.total;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    pagination.value.page = response.data.results.current_page;
    disable.value = false;
  } catch (error) {
    console.log(error);
  }
};

const listarRequisicoesDeletado = async (page = 1, rowsPerPage = 50) => {
  try {
    disable.value = true;
    let response = await store.dispatch("requisicao/listarDeletados", {
      somente_deletados: true,
      per_page: rowsPerPage,
      plantiff_search: filtros.value.listaUser
        ? store.state.autenticacao.usuarioLogado.id
        : filtros.value.solicitante,
      current_page: page,
    });
    listaRequisicao.value = response.data.results.data;
    quantidade.value = response.data.results.total;
    pagination.value.rowsPerPage = response.data.results.per_page;
    pagination.value.rowsNumber = response.data.results.total;
    pagination.value.page = response.data.results.current_page;
    disable.value = false;
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => tab.value,
  () => {
    escolherRequisicao();
  }
);

watch(
  [
    () => filtros.value.centro,
    () => filtros.value.solicitante,
    () => filtros.value.listaUser,
    () => filtros.value.intervalo,
    () => filtros.value.numeroRequisicao,
  ],
  () => {
    escolherRequisicao();
  }
);

onMounted(() => {
  escolherRequisicao();
});
</script>

<style scoped>
tbody tr td {
  white-space: pre-wrap;
}
</style>
